module.exports = __webpack_public_path__ + "static/img/jd.cd5467c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jd.jpeg
// module id = +Usr
// module chunks = 2